import { deleteEmailDomain } from "actions/Utilities/EmailDomain";
import { toast } from "components/toastNotification";
import React from "react";
import { useMutation } from "react-query";
import { useRecoilState } from "recoil";
import { emailDomainReFetching } from "../atoms/atoms";

export default function useDeactivateEmailDomain() {
  const [isReFetching, setIsReFetching] = useRecoilState(
    emailDomainReFetching
  );
  const { mutate } = useMutation(
    (ids: number[]) => deleteEmailDomain(ids),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire(
            "Disabling Email Domain failed",
            res.Message,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Email Domain Disabled Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Email Domain Disabled Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Disabling Email Domain failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "Email Domain not found":
              toast.fire(
                "Disabling Email Domain failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Disabling Email Domain failed", res, "error");
          }
        }
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error) => {
        toast.fire(
          "Disabling Email Domain failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );

  return mutate;
}
